import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Sticky from 'Components/Sticky';

import RFQFieldsSection from 'Components/RFQFieldsSection';
import { RFQDetailsFooter } from 'Components/RFQDetailsFooter';
import RFQLineItems from 'Components/RFQLineItems/index';
import Toast from 'Components/Toast'
import ActionLoader from 'Components/ActionLoader/index';
import ActionBlurLoader from 'Components/ActionLoader/LoaderWithBlur';
import Alert from 'Components/Alert';

import { getUser } from 'Utils/storage';
import {
   GET_RFQ_DETAIL,
   POST_BID,
   FETCH_BIDS,
   GET_TRIPS,
   COUNTER_PRICE,
   ACCEPT_REJECT_CP,
   ACCEPT_REJECT_LOI,
   UPLOAD_BIDDING_DETAILS,
   DOWNLOAD_BIDDING_DETAILS,
   EDIT_HEADING_CHARGES_URL,
   OTHER_COST_ACCEPT_REJECT_CP,
   DOWNLOAD_BIDDING_TRAIL,
   GET_ZONES,
   POST_COURIER_POST_BID,
   GET_MOVEMENTS,
   GET_MODES,
   CLEAR_MESSAGE,
   TOAST_ERROR,
   VENDOR_WITH_DRAW_BID,
   GET_VEHICLE_TYPES,
   GET_PAYMENT_CYCLES,
   DOWNLOAD_UPLOADED_FILE,
   GET_SEA_AND_AIR_LINES_LIST,
   GET_TRANSPORTER_LEVEL_PR_DETAILS,
   POST_ACCEPT_CEILING_PRICE_LOI,
   POST_COST_HEAD_CP_ACCEPT_REJECT,
   POST_COST_HEAD_COUNTER_PRICE,
   POST_COST_HEAD_COUNTER_ACCEPT_REJECT,
   GET_VEHICLE_TYPES_LIST,
   GET_EXIM_AWL_PLANT_WISE_COST_HEADS,
   GET_TERMS_AND_CONDITIONS
} from 'Constants/actionConstants';
import { ADANI, GREEN_PLY, TRANSPORTER } from 'Constants/commonConstants';
import Chat from 'Containers/Chat';
import { ReactComponent as BackIcon } from 'Icons/back.svg';

import { getToken } from 'Utils/storage';
import { CLEAR_TRIPS } from 'Constants/actionConstants';
import { CLEAR_RFQ_DETAIL, GET_IP_ADDRESS, GET_CURRENCY_DETAILS, GET_CURRENCY_TYPES } from 'Constants/actionConstants';
import { BIDS_TRANSPORTER_REFRESH_TIME, RFQ_DISPLAY_LIMIT, RFQ_PROV_DISPLAY_LIMIT, HIKAL} from 'Constants/commonConstants';
import ConfirmationPopup from 'Components/ConfirmationPopup/index';
import PRDetailsPopup from 'Components/PRDetailsPopup';
import { getItemFromLocal, setItemToLocal } from 'Utils/localStorage';
import ScreenTimeTrack from "Components/Common/ScreenTimeTrack/index";
import { screenInfoDetails } from 'Constants/screenInfoDetailsConstants';
class RFQDetails extends Component {

   getTripsTimer = null;
   state = {
      showFooter: true,
      isAccepted: false,
      showPopup: false,
      file: null,
      courierAcceptOrRejectLoiList: [],
      courierAcceptOrRejectCPList: [],
		isCourierAccepted: (localStorage.getItem('courierTermsAndConditionsAccepted') && JSON.parse(localStorage.getItem('courierTermsAndConditionsAccepted'))) ? true : false,
      bidSubmitList: [],
      bulkSubmitList: [],
      disposalBidList: [],
      termsAndConditionList: []
   }

   fetchRfq = (isFirstLoad = false) => {
      const { dispatch, match } = this.props;
      dispatch({
         type: GET_RFQ_DETAIL,
         params: {
            rfqId: match.params.id,
            rfqType: match.params.type,
            whoami: TRANSPORTER,
            seekerCompanyId: getItemFromLocal("transporter_seeker_company_id")
         },
         onSuccess: (data) => {
            if(isFirstLoad && data) {
               const isHIKAL = (HIKAL.includes(data.companyId));
               const isExim = [13,14,15].includes(data.type);
               if(isHIKAL || isExim) {
                  this.currencyDetails(data);
               }
               // if(isFirstLoad && data.allow_transporter_to_add_cost_head_during_bidding) {
               //    this.getPlantWiseCostHeads(data);
               // }
            }
         }
      });
   }

   getPlantWiseCostHeads = (onSuccess) => {
      const { dispatch, rfq } = this.props;
      dispatch({
         type: GET_EXIM_AWL_PLANT_WISE_COST_HEADS,
         params: {
            companyId: rfq.companyId,
            branchId: rfq.branchId,
            rfqType: rfq.type,
            incoTerms: rfq.eximIncoTerms
         },
         onSuccess
      })
   }

   getTermsAndConditionsList = () => {
      const { dispatch } = this.props;
      dispatch({
         type: GET_TERMS_AND_CONDITIONS,
         onSuccess: (details) => {
            this.setState({termsAndConditionList: details})
         }
      })
   }

   getTrips = (filters = {}, isFirstLoad = false) => {
      const { dispatch, match } = this.props;
      this.setState({
         filters
      })
      dispatch({
         type: GET_TRIPS,
         params: {
            isFirstLoad: isFirstLoad,
            rfqId: match.params.id,
            rfqType: match.params.type,
            limit: isFirstLoad ? RFQ_PROV_DISPLAY_LIMIT : RFQ_PROV_DISPLAY_LIMIT + 10, // this.props.tripsCount ? RFQ_PROV_DISPLAY_LIMIT : 1000, // isFirstLoad ? 10 : (RFQ_DISPLAY_LIMIT),
            offset: 0,
            whoami: TRANSPORTER,
            seekerCompanyId: getItemFromLocal("transporter_seeker_company_id"),
            ...filters
         },
         onSuccess: () => {
            this.fetchRfq();
            this.setGetTripsTimer();
            this.setState({
               showFooter: false
            }, () => {
               this.setState({
                  showFooter: true
               })
            })
         },
         onError: () => {
            this.fetchRfq();
            this.setGetTripsTimer();
            this.setState({
               showFooter: false
            }, () => {
               this.setState({
                  showFooter: true
               })
            })
         },
      });
   }
   setGetTripsTimer = () => {
      if (this.unmounted) { return };
      if (this.getTripsTimer) {
         clearTimeout(this.getTripsTimer)
      }
      this.getTripsTimer = setTimeout(() => {
         this.getTrips(this.state.filters);
      }, BIDS_TRANSPORTER_REFRESH_TIME * 1000)
   }

   bulkUpdateDataStore = (tripId, bidData, nextApiData) => {
      const { match, rfq } = this.props;
      const isHIKAL = (HIKAL.includes(rfq.companyId));
      const isExim = [13,14,15,16,31].includes(rfq.type);
      const { bulkSubmitList } = this.state;
      const list = {
            trip_id: tripId,
				price_usd: nextApiData && nextApiData.price_usd && Number(nextApiData.price_usd) || undefined,
            price_secondary: nextApiData && nextApiData.price_secondary && Number(nextApiData.price_secondary) || undefined,
            price_inr: nextApiData && nextApiData.price_inr && Number( nextApiData.price_inr) || undefined,
            estimated_time_of_departure_date: nextApiData && nextApiData.estimated_time_of_departure_date || undefined,
            estimated_time_of_arrival_date: nextApiData && nextApiData.estimated_time_of_arrival_date || undefined,
            base_price: nextApiData && nextApiData.base_price && Number(nextApiData.base_price) || undefined,
            base_price_usd: nextApiData && nextApiData.base_price_usd && Number(nextApiData.base_price_usd) || undefined,
            base_price_secondary: nextApiData && nextApiData.base_price_secondary && Number(nextApiData.base_price_secondary) || undefined,
            container_days_hours: (isHIKAL || isExim) && nextApiData && nextApiData.container_days_hours || undefined,
            container_free_day: (isHIKAL || isExim) && nextApiData && nextApiData.container_free_day || undefined,
            shipping_line_name: (isHIKAL || isExim) && nextApiData && nextApiData.shipping_line_name || undefined,
            liner_id: (isHIKAL || isExim) && nextApiData && nextApiData.liner_id || undefined,
            vessel_routing_type: (ADANI.includes(rfq.type) && isExim) && nextApiData && nextApiData.vessel_routing_type || undefined,
            isCostUpdate: true,
            transporterVol: '',
            extra_cost_per_km_price: nextApiData && nextApiData.extra_cost_per_km_price || undefined,
            ...bidData,
            ...nextApiData
         }
      if(list.liner_id) {
         const findIndexValue = (bulkSubmitList || []).findIndex(el => el.trip_id === list.trip_id && (el.liner_id === list.liner_id));
         if(findIndexValue > -1) {
            bulkSubmitList[findIndexValue] = list;
         } else {
            bulkSubmitList.push(list)
         }
         this.setState({ bulkSubmitList });
      }
   }

   getFreightRate = (data) => {
      const baseFreightObj = ((data.multi_mode_heading_charges || []).find(el => el.isBaseFreight) || {});
      const freightRate = baseFreightObj.headingChargesCp_inr && Number(baseFreightObj.headingChargesCp_inr).toFixed(2);
      return freightRate && Number(freightRate);
   }

   getFreightRateUsd = (data) => {
      const { currencyDetails } = this.props;
      const freightRate = this.getFreightRate(data);
      const conversionUSDObj = (currencyDetails || []).find(currencyObj => currencyObj.name === 'USD to INR');
      const freightRateUsd = freightRate && conversionUSDObj && conversionUSDObj.rupee && (freightRate / conversionUSDObj.rupee).toFixed(5);
      return freightRateUsd && Number(freightRateUsd);
   }

   postBid(tripId, bidData, nextApiData) {
      const { dispatch, match, rfq } = this.props;
      const isHIKAL = (HIKAL.includes(rfq.companyId));
      const isExim = [13,14,15,16,31].includes(rfq.type);
      if(rfq.type === 5 && !(isHIKAL || isExim) && !bidData.container_free_day) {
         dispatch({
            type: TOAST_ERROR,
            message: "Enter the Container Free Days"
        });
        return;
      } else if(((isHIKAL && rfq.type === 5) || [15].includes(rfq.type) || (rfq.shippingType !== 1 && [13, 14].includes(rfq.type))) && ((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType == 4) && !nextApiData.shipping_line_name) {
         dispatch({
            type: TOAST_ERROR,
            message: "Enter the Shipping Line"
        });
        return;
      }
      dispatch({
         type: POST_BID,
         params: {
            rfq_id: match.params.id,
            trip_id: tripId,
            rfqType: match.params.type && Number( match.params.type),
            ip_address: localStorage.getItem('IPAddress'),
				price_usd: nextApiData && nextApiData.price_usd && Number(nextApiData.price_usd) || undefined,
            price_secondary: nextApiData && nextApiData.price_secondary && Number(nextApiData.price_secondary) || undefined,
            price_inr: nextApiData && nextApiData.price_inr && Number( nextApiData.price_inr) || undefined,
            estimated_time_of_departure_date: nextApiData && nextApiData.estimated_time_of_departure_date || undefined,
            estimated_time_of_arrival_date: nextApiData && nextApiData.estimated_time_of_arrival_date || undefined,
            base_price: nextApiData && nextApiData.base_price && Number(nextApiData.base_price) || undefined,
            base_price_usd: nextApiData && nextApiData.base_price_usd && Number(nextApiData.base_price_usd) || undefined,
            base_price_secondary: nextApiData && nextApiData.base_price_secondary && Number(nextApiData.base_price_secondary) || undefined,
            container_days_hours: (isHIKAL || isExim) && nextApiData && nextApiData.container_days_hours || undefined,
            container_free_day: (isHIKAL || isExim) && nextApiData && nextApiData.container_free_day || undefined,
            shipping_line_name: (isHIKAL || isExim) && nextApiData && nextApiData.shipping_line_name || undefined,
            liner_id: (isHIKAL || isExim) && nextApiData && nextApiData.liner_id || undefined,
            extra_cost_per_km_price: nextApiData && nextApiData.extra_cost_per_km_price || undefined,
            seekerCompanyId: getItemFromLocal("transporter_seeker_company_id") || undefined,
            freight_rate: nextApiData && this.getFreightRate(nextApiData) || undefined,
            freight_rate_usd: (rfq.type === 15) && nextApiData && this.getFreightRateUsd(nextApiData) || undefined,
            ...bidData,
            exim_inco_terms: nextApiData && nextApiData.exim_inco_terms || undefined,
            provider_bid_remarks: (isExim) && nextApiData && nextApiData.provider_bid_remarks || undefined,
            provider_tat_time:(isExim) && nextApiData && nextApiData.provider_tat_time || undefined,
         },
         onSuccess: (() => {
            if (nextApiData && nextApiData.multi_mode_heading_charges) {
               this.updateHandlingCharges(nextApiData, true);
               if (this.getTripsTimer) {
                  clearTimeout(this.getTripsTimer)
               }
               dispatch({
                  type: CLEAR_TRIPS
               })
            } else {
               this.getTrips(this.state.filters);
            }
            if((isHIKAL || isExim)) {
               const { bulkSubmitList } = this.state;
               const findIndexValue = (bulkSubmitList || []).findIndex(el => el.trip_id === tripId && ([13,14].includes(rfq.type) ? (rfq.shippingType !== 1 && el.liner_id === (nextApiData && nextApiData.liner_id)) : el.liner_id === (nextApiData && nextApiData.liner_id)));
               if(findIndexValue > -1) {
                  bulkSubmitList.splice(findIndexValue, 1);
                  this.setState({ bulkSubmitList });
               }
            }
         })
      });
   }

   courierPostBid = (list) => {
      const { dispatch, match } = this.props;
      dispatch({
         type: POST_COURIER_POST_BID,
         params: {
            zone_bid_list: list,
            ip_address: localStorage.getItem('IPAddress')
         },
         onSuccess: (() => {
            this.getTrips(this.state.filters);
         })
      });
   }

   bulkPostBid = () => {
      const { dispatch, rfq } = this.props;
      const { bulkSubmitList } = this.state;
      const isHIKAL = (HIKAL.includes(rfq.companyId));
      const isExim = [13,14,15,16,31].includes(rfq.type);
      let sFlag = false;
      (bulkSubmitList || []).forEach(bidData => {
         if(((isHIKAL && rfq.type === 5) || isExim) && ((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType == 4) && !bidData.shipping_line_name) {
            sFlag = true;
         }
      })
      if(sFlag) {
         dispatch({
            type: TOAST_ERROR,
            message: "Enter the Shipping Line"
        });
        return;
      } else {
         this.postBidAll('', bulkSubmitList);
      }
   }
   
   postBidAll = (type, listOfObjects, loiRejectionReason) => {
      if (type == 2) {
         this.setState({
            loiLoader: true
         });
         if (listOfObjects.length == 0) {
            alert("Select to accept or reject LOIs")
            return;
         }
         for (var i = 0; i < listOfObjects.length; i++) {
            var data1 = listOfObjects[i];
            data1.is_accept = true;
         }
         const { dispatch, match } = this.props;
         dispatch({
            type: ACCEPT_REJECT_LOI,
            data: {
               rfq_id: match.params.id,
               rfqType: match.params.type && Number(match.params.type),
               trips: listOfObjects,
               is_list: true,
               ip_address: localStorage.getItem('IPAddress'),
               seekerCompanyId: getItemFromLocal("transporter_seeker_company_id")
            },
            onSuccess: () => {
               this.setState({
                  courierAcceptOrRejectLoiList: [],
                  courierAcceptOrRejectCPList: []
               })
               this.getTrips.bind(this, this.state.filters);
               setTimeout(() => this.setState({
                  loiLoader: false
               }), 7000);
            }
               
         });
      }
      else if (type == 3) {
         this.setState({
            loiLoader: true
         });
         if (listOfObjects.length == 0) {
            alert("Select to accept or reject LOIs")
            return;
         }
         for (var i = 0; i < listOfObjects.length; i++) {
            var data1 = listOfObjects[i];
            data1.is_accept = false;
         }

         const { dispatch, match } = this.props;
         dispatch({
            type: ACCEPT_REJECT_LOI,
            data: {
               rfq_id: match.params.id,
               rfqType: match.params.type && Number(match.params.type),
               trips: listOfObjects,
               is_list: true,
               ip_address: localStorage.getItem('IPAddress'),
               loi_rejection_reason : loiRejectionReason,
               seekerCompanyId: getItemFromLocal("transporter_seeker_company_id")
            },
            onSuccess: () => {
               this.setState({
                  courierAcceptOrRejectLoiList: [],
                  courierAcceptOrRejectCPList: []
               });
               if((match.params.type && Number(match.params.type)) === 9) {
                  let { bidSubmitList } = this.state;
                  bidSubmitList = bidSubmitList.filter(bid => bid.lot_trip_child_id !== (listOfObjects[0] || {}).lot_trip_child_id);
                  this.setState({
                     bidSubmitList
                  });
               }
               this.getTrips.bind(this, this.state.filters);
               setTimeout(() => this.setState({
                  loiLoader: false
               }), 7000);
            }
         });
      }
      else {
         const { dispatch, match } = this.props;
         if (listOfObjects.length == 0) {
            alert("Please submit bids");
            return;
         }
         else {
            dispatch({
               type: POST_BID,
               params: {
                  rfq_id: match.params.id,
                  rfqType: match.params.type && Number(match.params.type),
                  trips: listOfObjects,
                  ip_address: localStorage.getItem('IPAddress'),
                  isList: true,
                  seekerCompanyId: getItemFromLocal("transporter_seeker_company_id") || undefined,
               },
               onSuccess: () => {
                  this.setState({ bulkSubmitList: [], disposalBidList: [] })
                  dispatch({
                     type: CLEAR_TRIPS
                  });
                  this.getTrips(this.state.filters);
               }

            });
         }
      }
   }

   fetchBids(tripId, linerId) {
      const { dispatch, match } = this.props;
      dispatch({
         type: FETCH_BIDS,
         params: {
            tripId: tripId,
            rfqType: match.params.type,
            linerId: linerId || undefined,
            whoami:TRANSPORTER,
            seekerCompanyId: getItemFromLocal("transporter_seeker_company_id")
         }
      });
   }
   postChallengePrice(tripId, bidData) {
      const { dispatch, match} = this.props;
      const bidDataObject = { ...bidData };
      bidDataObject.counter_price = bidDataObject.price;
      delete bidDataObject['price'];
      // if (GREEN_PLY.includes(rfq.companyId)) {
      //    bidDataObject.price = bidDataObject.price;
      // }
      // if (!GREEN_PLY.includes(rfq.companyId)){
      //    delete bidDataObject['price'];
      // }
      dispatch({
         type: COUNTER_PRICE,
         params: {
            counter_offer_list: [{
               rfq_id: match.params.id,
               rfqType: match.params.type && Number(match.params.type),
               trip_id: tripId,
               seekerCompanyId: getItemFromLocal("transporter_seeker_company_id"),
               ...bidData
            }],
            ip_address: localStorage.getItem('IPAddress')
         },
         onSuccess: this.getTrips.bind(this, this.state.filters)
      });
      // this.getTrips(dispatch, match);
   }
   acceptLoi = (trip) => {
      const { dispatch, match } = this.props;
      this.setState({
         loiLoader: true
      })
      dispatch({
         type: ACCEPT_REJECT_LOI,
         data: {
            rfq_id: match.params.id,
            ip_address: localStorage.getItem('IPAddress'),
            rfqType: match.params.type && Number(match.params.type),
            seekerCompanyId: getItemFromLocal("transporter_seeker_company_id"),
            accept_or_reject_list: [
               {
                  trip_id: trip.id,
                  liner_id: trip.linerId || undefined,
                  is_accept: true,
                  is_loi_with_cp_sent: trip.isLoiWithCPSent,
                  challenge_price: trip.challengePrice
               }
            ]
         },
         onSuccess: () => {
            this.getTrips.bind(this);
            setTimeout(() => this.setState({
               loiLoader: false
            }), 7000);
         }
      });
   }
   rejectLoi = (trip, loiRejectionReason) => {
      const { dispatch, match } = this.props;
      this.setState({
         loiLoader: true
      });
      dispatch({
         type: ACCEPT_REJECT_LOI,
         data: {
            rfq_id: match.params.id,
            rfqType: match.params.type && Number(match.params.type),
            ip_address: localStorage.getItem('IPAddress'),
            seekerCompanyId: getItemFromLocal("transporter_seeker_company_id"),
            accept_or_reject_list: [
               {
                  trip_id: trip.id,
                  liner_id: trip.linerId || undefined,
                  is_accept: false,
                  is_loi_with_cp_sent: trip.isLoiWithCPSent,
                  challenge_price: trip.challengePrice,
                  loi_rejection_reason :loiRejectionReason
               }
            ]
         },
         onSuccess: () => {
            this.getTrips.bind(this);
            setTimeout(() => this.setState({
               loiLoader: false
            }), 7000);
         }
      });
   }

   setAcceptOrRejectLoiList = (data, cpData) => {
      this.setState({ courierAcceptOrRejectLoiList: data, courierAcceptOrRejectCPList: cpData });
   }

   refreshBids = (filters) => {
      const { dispatch } = this.props;
      dispatch({
         type: CLEAR_TRIPS,
      });
      this.getTrips(filters);
   }
   uploadBiddingDetails = ({ file } = this.state) => {
      this.setState({ showPopup: true });
      const { dispatch, match, rfq } = this.props;
      const rfqType = rfq.type
      const serviceType = rfq.serviceType;
      dispatch({
         type: UPLOAD_BIDDING_DETAILS,
         file,
         params: {
            serviceType: (serviceType === 3 && rfqType === 4) ? 2 :(rfqType === 1) ? 3 : (rfqType === 2 || rfqType === 5) ? 4 : 5,
            rfqId: match.params.id,
            rfqType,
            ip_address: localStorage.getItem('IPAddress'),
            seekerCompanyId: getItemFromLocal("transporter_seeker_company_id")
         },
         whoami: TRANSPORTER,
         onSuccess: () => {
            dispatch({
               type: CLEAR_TRIPS
            });
            this.getTrips();
         },
         onError: () => {
            if(match.params.type == 9) {
               dispatch({
                  type: CLEAR_TRIPS
               });
               this.getTrips();
            }
         }
      });
   }
   downloadBiddingDetails = () => {
      const { dispatch, match } = this.props;
      const rfqType = this.props.rfq.type
      const serviceType =this.props.rfq.serviceType;
      dispatch({
         type: DOWNLOAD_BIDDING_DETAILS,
         params: {
            serviceType:(serviceType===3 && rfqType === 4)?2:(rfqType === 1) ? 3 : (rfqType === 2 || rfqType === 5) ? 4 : 5,
            rfqType,
            rfqId: match.params.id,
            seekerCompanyId: getItemFromLocal("transporter_seeker_company_id")
         },
         onSuccess: (data) => {
            this.setState({
               downloadBiddingDetailsUrl: data.url
            }, () => {
               this.downloadBiddingDetailsButton.click();
            })
         },
         whoami: TRANSPORTER
      });
   }

   acceptRejectCP = (tripId, isAccept) => {
      const { dispatch, match } = this.props;
      dispatch({
         type: ACCEPT_REJECT_CP,
         data: {
            "rfq_id": match.params.id,
            rfqType: match.params.type && Number(match.params.type),
            "ip_address": localStorage.getItem('IPAddress'),
            seekerCompanyId: getItemFromLocal('transporter_seeker_company_id'),
            "accept_or_reject_list": [
               {
                  "trip_id": tripId,
                  "is_accept": isAccept,
               }
            ]
         }
      })
   }

   bulkAcceptRejectCP = (tripDetails, isAccept) => {
      const { dispatch, match } = this.props;
      if(isAccept) {
         dispatch({
            type: COUNTER_PRICE,
            params: {
               counter_offer_list: tripDetails,
               rfqType: match.params.type && Number(match.params.type),
               ip_address: localStorage.getItem('IPAddress'),
               seekerCompanyId: getItemFromLocal("transporter_seeker_company_id")
            },
            onSuccess: this.getTrips.bind(this, this.state.filters)
         });
      }
      dispatch({
         type: ACCEPT_REJECT_CP,
         data: {
            "rfq_id": match.params.id,
            rfqType: match.params.type && Number(match.params.type),
            "ip_address": localStorage.getItem('IPAddress'),
            seekerCompanyId: getItemFromLocal('transporter_seeker_company_id'),
            "accept_or_reject_list": tripDetails.map(trip => {
               return {
                  "trip_id": trip.trip_id,
                  "is_accept": isAccept
               }
            })
         },
         onSuccess: () => {
            this.setState({ courierAcceptOrRejectCPList: [] });
         }
      })
   }

   otherCostAcceptRejectCP = (item, otherCostType) => {
      const { dispatch, match } = this.props;
      dispatch({
         type: OTHER_COST_ACCEPT_REJECT_CP,
         data: {
            "rfq_id": match.params.id,
            [otherCostType]: item,
            seekerCompanyId: getItemFromLocal('transporter_seeker_company_id')
         },
         onSuccess: this.getTrips.bind(this, this.state.filters)
      })
   }

   isTermAccepted = (type,val) => {
		if(type === 1){
			this.setState({ isAccepted: val });
			localStorage.setItem('termsAndConditionsAccepted', val);
		}else{
			this.setState({ isCourierAccepted: val });
			localStorage.setItem('courierTermsAndConditionsAccepted', val);
		}	
   }

   shouldBid = (file) => {
      if (file) {
         this.setState({
            file,
            showPopup: true,
         })
      }
   }

   onConfirm = () => {
		this.uploadBiddingDetails();
		this.setState({ showPopup: false });
		localStorage.setItem('termsAndConditionsAccepted', false);
   }

   onCancel = () => {
      this.setState({
         showPopup: false
      }, () => {
         this.setGetTripsTimer();
         // this.getTrips();
      });
   }

   componentDidMount() {
      const { dispatch ,rfq} = this.props;
      this.fetchRfq(true);
      this.getTrips({}, true);
      this.getZones();
      dispatch({ type: GET_MOVEMENTS });
      dispatch({ type: GET_MODES });
      dispatch({ type: GET_IP_ADDRESS });
      dispatch({ type: GET_CURRENCY_TYPES });
      // dispatch({ type: GET_PAYMENT_CYCLES });
      dispatch({ 
         type: GET_SEA_AND_AIR_LINES_LIST,
         data: {
            seekerCompanyId: getItemFromLocal("transporter_seeker_company_id")
         }
      });
      this.getTermsAndConditionsList();
   }

   componentDidUpdate(prevProps, prevState) {
      const { rfq } = this.props;
      const C1 = !!rfq;
      if (C1) {
         const branchId = !!prevProps
            ? !!prevProps.rfq
               ? prevProps.rfq.branchId
               : ''
            : ''
         if (rfq.branchId !== branchId) {
            this.handleGetVehicleTypesList()
         }
      }
   }

   handleGetVehicleTypesList = () => {
      const { dispatch ,rfq} = this.props;
      const user = getUser();
      const queryParams = {
         rfqType: rfq.type,
			companyId: rfq.companyId,
			branchId: rfq.branchId
      }

      dispatch({
        type: GET_VEHICLE_TYPES_LIST,
        queryParams
      });
    };

   getZones = () => {
      const { dispatch } = this.props;
      dispatch({
         type: GET_ZONES
      })
   }

   componentWillUnmount() {
      this.unmounted = true;
      clearTimeout(this.getTripsTimer);
      const { dispatch } = this.props;
      dispatch({
         type: CLEAR_RFQ_DETAIL
      });
      dispatch({
         type: CLEAR_TRIPS
      });
   }

   clickedFileUpload = () => {
      // this.unmounted = true;
      clearTimeout(this.getTripsTimer);
   }

   updateHandlingCharges = (data, isRefresh) => {
      const { dispatch, match, rfq } = this.props;
      const newCostHeads = (data.multi_mode_heading_charges || []).filter(el => el.isNewlyAdded);
      (data.multi_mode_heading_charges || []).forEach(el => {
         delete el.isNewlyAdded;
      });
      dispatch({
         type: EDIT_HEADING_CHARGES_URL,
         data: {
            seekerCompanyId: getItemFromLocal("transporter_seeker_company_id"),
            ...data,
            cost_head: (newCostHeads || []).map(el => {
               return {
                  name: el.headingChargesValue,
                  id: el.headingChargesID
               }
            }),
            freight_rate: this.getFreightRate(data)
         },
         rfqType: match.params.type && Number(match.params.type),
         onSuccess: () => {
            const additionalLineItems = getItemFromLocal('additionalLineItems');
            if(additionalLineItems && additionalLineItems.length > 0) {
               const filterLineItems = additionalLineItems.filter(el => data.linerId != el.linerId);
               setItemToLocal('additionalLineItems', filterLineItems);
            }
            if(isRefresh) {
               dispatch({
                  type: CLEAR_TRIPS
               });
               this.getTrips(this.state.filters);
            }
         }
      })
   }

   downloadProviderBidTrailDetails = () => {
      const { dispatch, match } = this.props;
      const user = getUser();
      dispatch({
         type: DOWNLOAD_BIDDING_TRAIL,
         params: {
            type: match.params.type == 9 ? 9 : undefined,
            rfqId: match.params.id,
            rfqType: match.params.type,
            transporterId:user.companyId,
            seekerCompanyId: getItemFromLocal("transporter_seeker_company_id"),
         }, 
         onSuccess: (data) => {
            this.setState({
               downloadBiddingDetailsUrl: data.url
            }, () => {
               this.downloadBiddingDetailsButton.click();
            })
         },
         whoami: TRANSPORTER
      });
   }

   clearMessage = () => {
      const { dispatch, match } = this.props;
      dispatch({
         type: CLEAR_MESSAGE,
         params: {
            rfqId: match.params.id
         },
         onSuccess: (data) => {
            if(data)
            this.fetchRfq();
         }
      });
		localStorage.setItem('termsAndConditionsAccepted', true);


   };	

	alertCancel = () => {
		this.setState({
			isCourierAccepted:true
		})
	}

	currencyDetails = (rfq) => {
		const { dispatch } = this.props;
		dispatch({
         type: GET_CURRENCY_DETAILS,
         data: {
            companyId: rfq.companyId,
            branchId: rfq.branchId,
            seekerCompanyId: getItemFromLocal("transporter_seeker_company_id")
         }
		});
	};	

   vendorWithDrawBid(bid) {
      const { dispatch, match } = this.props;
		dispatch({
         type: VENDOR_WITH_DRAW_BID,
         data: {
            rfq_id:bid.rfq_id,
            trip_id: bid.trip_id,
            liner_id: bid.liner_id,
            rfqType: match.params.type && Number(match.params.type),
            ip_address: localStorage.getItem('IPAddress'),
            seekerCompanyId: getItemFromLocal("transporter_seeker_company_id")
        },
		});
   }

   postDisposalBid = (data, type, isError, lineItem, trip) => {
      const isDepotWise = (((this.props.rfq || {}).rfqDetails || {}).disposalContractType !== 2);
      let { bidSubmitList } = this.state;
      const findIndex = (bidSubmitList || []).findIndex(bid => !isDepotWise ? ((bid.lot_trip_child_id === data.lot_trip_child_id) && (bid.material_code_description === data.material_code_description)) : (bid.trip_id === data.trip_id));
      if(findIndex === -1)  {
         if(data.price) {
            bidSubmitList.push(data);
         } 
      } else {
         if(type === 2 || (!(data.price) && !lineItem.price)) {
            bidSubmitList.splice(findIndex, 1);
         } else {
            bidSubmitList[findIndex] = data;
         }
      }
      if(data.price && data.price !== lineItem.price) {
         if(!isDepotWise) {
            this.readyToPostBid(bidSubmitList);
         } else {
            const tripPrice = (trip.sub_trip_disposal_product || []).filter(sTrip => sTrip.price);
            const bidList = (bidSubmitList || []).filter(sBid => sBid.lot_trip_child_id === trip.lot_trip_parent_id);
            if(!tripPrice.length && (bidList.length === trip.sub_trip_disposal_product.length)) {
               // console.log('bidSubmitList', bidSubmitList, bidList);
               this.readyToPostBid(bidList);
            } else if((tripPrice.length === trip.sub_trip_disposal_product.length)  && bidList.length > 0) {
               // this.props.postBidAll(1, bidList);
               //  console.log('bidSubmitList', bidSubmitList, bidList);
               this.readyToPostBid(bidList);
            }
         }
     } else {
         this.readyToPostBid(bidSubmitList);
     }
     console.log('bidSubmitList', bidSubmitList);
      this.setState({ bidSubmitList, isDisposalError: isError });
   }

   getVehicleTypes = () => {
		const { rfq, dispatch } = this.props;
		const params = {
			rfqType: rfq.type,
			companyId: rfq.companyId,
			branchId: rfq.branchId
		}
		dispatch({
			type: GET_VEHICLE_TYPES,
			params
		})
	}

   downloadUploadedFile = (fileName) => {
      const { dispatch } =  this.props;
      const user = getUser();
      let companyId = ''
      if(user.companyType == 2){
         companyId =  getItemFromLocal('transporter_seeker_company_id')
      }
      dispatch({
         type: DOWNLOAD_UPLOADED_FILE,
         param: {
            fileName,
            companyId
         }
      })
   }

   showPRDetails = (tripId) => {
      const { dispatch, rfq } = this.props;
      dispatch({
         type: GET_TRANSPORTER_LEVEL_PR_DETAILS,
         data: {
            rfqId: rfq.id,
            tripId
         },
         isTransporter: true,
         onSuccess: (data) => {
            this.setState({
					showPRPopup: true,
					PRData:  data || [],
					isTransporter: true
				})
         }
      })
   }

   readyToPostBid = (bidList = []) => {
      this.setState({
         disposalBidList: bidList
      });
   }
   
   render() {
      const {
         rfq,
         trips,
         pricingBasis,
         paymentCycles,
         tripBids,
         tripsCount,
         loadingTrips,
         submittingAcceptRejectLoi,
         uploadingBiddingDetails,
         downloadingBiddingDetails,
         vehicleTypes,
         vehicleBodyTypes,
         systemTime,
         downloadBidTrailDetails,
         otherCharges,
         courierMovements,
         courierModes,
         slabList,
         currencyDetails,
         additionalZoneList,
         fromZones,
         toZones,
         currencyTypes,
         tZones,
         plantNames,
         materials,
         distNames,
         totalValueVisibilityOnProvider,
         chatBoxEnable,
         seaAndAirLines,
         totalValueVisibilityOfL1OnProvider,
         visibilityOfLotRankingForProvider,
         maxCountToWithdrawBid,
         totalBidExtension,
         loiCeilingAccepted,
         vehicleTypesList,
         allowTransporterToAddCostHeadDuringBidding,
         transporterBiddedCount
      } = this.props;
      let biddingStage = {
         'yetToStart': false,
         'inProgress': false,
         'complete': false
      };
      if (rfq) {
         const currentDate = moment(new Date(systemTime));
         const biddingStart = moment(rfq.rfqDetails.biddingStart);
         const biddingEnd = moment(rfq.rfqDetails.biddingEnd);

         // on obj to hold status! yako ond variable yochne mad de guldu khan!
         biddingStage['yetToStart'] = biddingStart.isAfter(currentDate);
         biddingStage['inProgress'] = currentDate.isAfter(biddingStart) && biddingEnd.isAfter(currentDate);
         biddingStage['complete'] = currentDate.isAfter(biddingStart) && currentDate.isAfter(biddingEnd);

         const currDate = moment(new Date(systemTime));
         if (trips && trips.length > 0 && trips[trips.length - 1].relayEndTime && currDate.isAfter(biddingEnd)) {
            biddingStage['inProgress'] = currDate.isAfter(biddingStart) && moment(trips[trips.length - 1].relayEndTime).isAfter(currDate);
            biddingStage['complete'] = currDate.isAfter(biddingStart) && (currDate).isAfter(moment(trips[trips.length - 1].relayEndTime));
         }
      }
      const lineItems = [...trips];
      return (
         <div>
            <Sticky>
               <ScreenTimeTrack
                  screenInfoDetailsItem={
                     screenInfoDetails.RFQ_DETAILS_SCREEN
                  }
               />
               {(submittingAcceptRejectLoi || this.state.loiLoader) && <ActionBlurLoader fixed={true} />}
               {(!rfq || loadingTrips || uploadingBiddingDetails || downloadingBiddingDetails || downloadBidTrailDetails) && <ActionLoader fixed={true} />}
               {
                  rfq &&
                  <div>
                     <div className="ht-60 flex flex-middle pl-20 curP" onClick={() => this.props.history.goBack()}>
                        <BackIcon className="mr-10 fill-theme curP" />
                        <div className="flex flex-bottom">
                           <div className="header-dark-color fs-16 fBold mr-5">{rfq.rfqDetails.name}</div>
                           <div className="table-text-color fRegular fs-12 op-79 lh-15p">RFQ {rfq.rfqNumber}</div>
                        </div>
                     </div>
                     <div className="col-1">
                        <div className="flex flex-1 pl-20 pr-20 flex-column pb-150 mb-50 col-1">
									<RFQFieldsSection
                           rfq={rfq}
                           isTermAccepted={this.isTermAccepted}
                           isCourierTermAccepted={this.isTermAccepted}
                           termsAndConditionList={this.state.termsAndConditionList}
                           dispatch={this.props.dispatch}
                           termsAccepted={this.props.termsAccepted}
                           />
                           <RFQLineItems
                              rfq={rfq}
                              lineItems={lineItems}
                              biddingStage={biddingStage}
                              postBid={this.postBid.bind(this)}
                              postBidAll={this.postBidAll.bind(this)}
                              pricingBasis={pricingBasis}
                              paymentCycles={paymentCycles}
                              vehicleTypes={vehicleTypes}
                              vehicleBodyTypes={vehicleBodyTypes}
                              tripBids={tripBids}
                              fetchBids={this.fetchBids.bind(this)}
                              postChallengePrice={this.postChallengePrice.bind(this)}
                              acceptLoi={this.acceptLoi}
                              rejectLoi={this.rejectLoi}
                              getTrips={this.refreshBids}
                              tripsCount={rfq.rfqDetails.tripsCount}
                              loadingTrips={loadingTrips}
                              paymentBasis={rfq.paymentBasis}
                              acceptRejectCP={this.acceptRejectCP}
                              systemTime={systemTime}
                              updateHandlingCharges={this.updateHandlingCharges}
                              otherCostAcceptRejectCP={this.otherCostAcceptRejectCP}
                              courierZones ={this.props.courierZones}
                              courierPostBid={this.courierPostBid}
                              otherCharges={otherCharges}
                              courierMovements={courierMovements}
                              courierModes={courierModes}
                              courierAcceptOrRejectLoiList={this.state.courierAcceptOrRejectLoiList}
                              setAcceptOrRejectLoiList={this.setAcceptOrRejectLoiList}
                              slabList={slabList}
                              courierAcceptOrRejectCPList={this.state.courierAcceptOrRejectCPList}
										isCourierTermAccepted={this.state.isCourierAccepted && JSON.parse(localStorage.getItem('termsAndConditionsAccepted')) && JSON.parse(localStorage.getItem('courierTermsAndConditionsAccepted'))}
                              currencyDetails={currencyDetails}
                              additionalZoneList={additionalZoneList}
                              fromZones={fromZones}
                              toZones={toZones}
                              currencyTypes={currencyTypes}
                              vendorWithDrawBid = {this.vendorWithDrawBid.bind(this)}
                              tZones ={tZones}
                              plantNames ={plantNames}
                              materials ={materials}
                              distNames = {distNames}
                              postDisposalBid={this.postDisposalBid}
                              bidSubmitList={this.state.bidSubmitList}
                              totalValueVisibilityOnProvider={totalValueVisibilityOnProvider}
                              totalValueVisibilityOfL1OnProvider={totalValueVisibilityOfL1OnProvider}
                              visibilityOfLotRankingForProvider={visibilityOfLotRankingForProvider}
                              maxCountToWithdrawBid={maxCountToWithdrawBid}
                              getVehicleTypes={this.getVehicleTypes}
                              seaAndAirLines={seaAndAirLines}
                              bulkUpdateDataStore={this.bulkUpdateDataStore}
                              showPRDetails={this.showPRDetails}
                              readyToPostBid={this.readyToPostBid}
                              loiCeilingAccepted={loiCeilingAccepted}
                              postCostHeadCP={this.postCostHeadCP}
                              postCostHeadCounterPrice={this.postCostHeadCounterPrice}
                              vehicleTypesList ={vehicleTypesList}
                              allowTransporterToAddCostHeadDuringBidding={allowTransporterToAddCostHeadDuringBidding}
                              getPlantWiseCostHeads={this.getPlantWiseCostHeads}
                              transporterBiddedCount={transporterBiddedCount}
                           />
                        </div>
                     </div>
                     <a href={this.state.downloadBiddingDetailsUrl} className="dNone" ref={(ref) => { this.downloadBiddingDetailsButton = ref; }}>Download Bidding Details</a>
                     {rfq && chatBoxEnable && <Chat rfq={rfq} userType={TRANSPORTER} userId={getToken()} />}
                     {this.state.showFooter &&
                        <RFQDetailsFooter
                           rfq={rfq}
                           showPopup={this.state.showPopup}
                           confirm={this.onConfirm}
                           cancel={this.onCancel}
                           systemTime={systemTime}
                           uploadBiddingDetails={this.shouldBid}
                           downloadBiddingDetails={this.downloadBiddingDetails}
                           isTermAccepted={this.state.isAccepted}
                           clickedFileUpload={this.clickedFileUpload}
                           downloadProviderBidTrailDetails ={this.downloadProviderBidTrailDetails}
                           courierAcceptOrRejectLoiList={this.state.courierAcceptOrRejectLoiList}
                           postBidAll={this.postBidAll}
                           courierAcceptOrRejectCPList={this.state.courierAcceptOrRejectCPList}
                           bulkAcceptRejectCP={this.bulkAcceptRejectCP}
                           courierBidStatus ={rfq.rfqDetails.courierBidStatus}
                           clearMessage = {this.clearMessage}
									isCourierTermAccepted={this.state.isCourierAccepted}
                           biddingStage={biddingStage}
                           bulkPostBid={this.bulkPostBid}
                           bulkSubmitList={this.state.bulkSubmitList}
                           totalBidExtension={totalBidExtension}
                           disposalBidList={this.state.disposalBidList}
                           transporterBiddedCount={transporterBiddedCount}
                           tripsCount={tripsCount}
                        />
                     }
							{(rfq.type === 4 || rfq.rfqDetails.serviceType === 3) && this.state.isCourierAccepted === false && <Alert text="Please Accept Terms And Conditions & Service Availability" onCancel={this.alertCancel} />}

                  </div>
               }
            </Sticky>
            {
               this.state.isDisposalError && 
               <ConfirmationPopup
                  text={'Bid Price should be greater than MSP'}
                  onCancel={() => this.setState({ isDisposalError: false })}
                  isTextErrorColor={true}
               />
            }
            {
               this.state.showPRPopup && 
               <PRDetailsPopup
                  data={this.state.PRData} 
                  onCancel={() => { this.setState({ showPRPopup: false }) }}
                  isTransporter={true}
               />
            }
         </div>
      )
   }
}


const mapStateToProps = ({ constants, rfq, contracting, common ,supplierRFQCreateOrUpdateRequest}) => {
   return {
      groups: constants.groups || [],
      transporters: constants.transporters || [],
      rfq: rfq.createdRFQ,
      activeView: rfq.activeView,
      creatingRFQ: rfq.createRFQ.dataSubmitting,
      trips: rfq.trips.data,
      tripsCount: rfq.trips.tripsCount,
      addingTrip: rfq.trips.addingTrip,
      documents: rfq.documents.data || [],
      tripBids: rfq.tripBids,
      loadingTrips: rfq.trips.dataLoading,
      submittingAcceptRejectLoi: contracting.acceptRejectLoi.dataSubmitting,
      uploadingBiddingDetails: contracting.uploadBiddingDetails.dataSubmitting,
      downloadingBiddingDetails: contracting.downloadBiddingDetails.dataSubmitting,
      downloadBidTrailDetails :contracting.downloadBidTrailDetails.dataSubmitting,

      //CONSTANTS
      packingTypes: constants.packingTypes || [],
      vehicleTypes: constants.vehicleTypes || [],
      vehicleBodyTypes: constants.vehicleBodyTypes || [],
		currencyDetails: constants.currencyDetails || [],
      paymentCycles: constants.paymentCycles || [],
      businessVolumes: constants.businessVolumes || [],
      pricingBasis: constants.pricingBasis || [],
      slabs: constants.slabs || [],


      systemTime: common.systemTime,
      courierZones: constants.courierZones || [],
      otherCharges: rfq.trips.otherCharges || [],
      courierMovements: constants.courierMovements || [],
      courierModes: constants.courierModes || [],
      slabList: rfq.trips.slabList || [],
      additionalZoneList: rfq.trips.additionalZoneList || [],
      fromZones: rfq.trips.fromZones || [],
      toZones: rfq.trips.toZones || [],
      currencyTypes: constants.currencyTypes || [],
      tZones: rfq.trips.tZones || [],
      plantNames : rfq.trips.plantNames || [],
      materials : rfq.trips.materials || [],
      distNames : rfq.trips.distNames || [],
      totalValueVisibilityOnProvider: rfq.trips.totalValueVisibilityOnProvider || false,
      chatBoxEnable: rfq.trips.chatBoxEnable || false,
      seaAndAirLines: constants.seaAndAirLines || {},
      totalValueVisibilityOfL1OnProvider: rfq.trips.totalValueVisibilityOfL1OnProvider || false,
      visibilityOfLotRankingForProvider: rfq.trips.visibilityOfLotRankingForProvider || false,
      maxCountToWithdrawBid: rfq.trips.maxCountToWithdrawBid || '',
      totalBidExtension: rfq.trips.totalBidExtension || 0,
      loiCeilingAccepted: rfq.trips.loiCeilingAccepted || false,
      vehicleTypesList: supplierRFQCreateOrUpdateRequest.vehicleTypesList || [],
      allowTransporterToAddCostHeadDuringBidding: rfq.trips.allowTransporterToAddCostHeadDuringBidding || false,
      transporterBiddedCount: rfq.trips.transporterBiddedCount || 0,
      termsAccepted: rfq.trips.termsAccepted || false
   }
};


export default connect(mapStateToProps)(RFQDetails);
